function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { getDefaultRpcInstance } from '../../internal/rpc/defaultRpc';
import { v4 as uuid } from 'uuid';
const rpcMethodMap = {
    increment: 'metricsIncrement',
    gauge: 'metricsGauge',
    set: 'metricsSet'
};
const method = (name)=>{
    return (config, ...params)=>{
        var _config_metrics, _config__internal_observability_metrics, _config__internal_observability;
        if (!config || ((_config_metrics = config.metrics) === null || _config_metrics === void 0 ? void 0 : _config_metrics.disabled)) {
            return;
        }
        if (config._tmp_dualReporting) {
            const index = name === 'increment' ? 1 : 2;
            params[index] = _object_spread_props(_object_spread({}, params[index]), {
                _tdr_id: uuid()
            });
        }
        const injectedMethod = (_config__internal_observability = config._internal_observability) === null || _config__internal_observability === void 0 ? void 0 : (_config__internal_observability_metrics = _config__internal_observability.metrics) === null || _config__internal_observability_metrics === void 0 ? void 0 : _config__internal_observability_metrics[name];
        if (injectedMethod) {
            // @ts-expect-error Passed in `params` is a union of tuples.
            injectedMethod(config, ...params);
            if (!config._tmp_dualReporting) {
                return;
            }
        }
        var _config_rpc;
        const rpcClient = (_config_rpc = config.rpc) !== null && _config_rpc !== void 0 ? _config_rpc : getDefaultRpcInstance().client;
        const rpcMethod = rpcMethodMap[name];
        const paramsWithPotentialDualReporting = config._tmp_dualReporting ? [
            `_tdr.${params[0]}`,
            ...params.slice(1)
        ] : params;
        rpcClient.call(rpcMethod, config, ...paramsWithPotentialDualReporting);
    };
};
/**
 * @see https://sail.stripe.me/observability/api/useMetrics#increment
 */ export const increment = method('increment');
/**
 * @see https://sail.stripe.me/observability/api/useMetrics#gauge
 */ export const gauge = method('gauge');
/**
 * @see https://sail.stripe.me/observability/api/useMetrics#set
 */ export const set = method('set');

//# sourceMappingURL=metrics.client.js.map